// Lib
import './lib/q'
import rua from './lib/rua'

// Bootstrap
import '../../../node_modules/bootstrap/js/dist/tab'
import '../../../node_modules/bootstrap/js/dist/collapse'
import '../../../node_modules/bootstrap/js/dist/modal'

// Views
import glob from './views/glob'

// Components
import home from './views/home'
class global {
  constructor() {}

  start() {
    glob.init()
    home.init()
  }

  onLoad() {
    document.body.classList.add('loaded')
    glob.load()
    home.load()
    rua.init()
  }

  preLoad() {}
  loadComplete() {}
}
const app = new global()

// Window Events
window.addEventListener('DOMContentLoaded', () => app.start(), false)
window.addEventListener(
  'load',
  () => {
    app.onLoad()
    app.loadComplete()
    calcHeight()
  },
  false
)
window.addEventListener(
  'scroll',
  () => {
    const scrollTop =
      window.pageYOffset !== undefined
        ? window.pageYOffset
        : (document.documentElement || document.body.parentNode || document.body).scrollTop

    if (scrollTop > 0) document.body.classList.add('has-scrolled')
    else document.body.classList.remove('has-scrolled')
  },
  false
)

window.addEventListener('resize', () => calcHeight())

const calcHeight = () => {
  let vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--window-height', `${vh}px`)
}
